import _ from 'lodash'
import { Country } from 'common/types'

/**
 * Sorts countries with United States first, then alphabetically by name
 * @param countries - Array of countries to sort
 * @returns Sorted array with United States first
 */
export const sortCountriesWithUSFirst = (countries: Country[]): Country[] => {
  if (!countries || countries.length === 0) {
    return countries
  }

  const usCountry = countries.find(
    (country) =>
      country.name?.toLowerCase() === 'united states' || country.code?.toLowerCase() === 'us',
  )

  const otherCountries = countries.filter(
    (country) =>
      country.name?.toLowerCase() !== 'united states' && country.code?.toLowerCase() !== 'us',
  )

  const sortedOtherCountries = _.sortBy(otherCountries, 'name')

  return usCountry ? [usCountry, ...sortedOtherCountries] : sortedOtherCountries
}
